import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Callout } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Info } from 'baby-design/icons'

const QuantityCallout: React.FC = () => (
  <Callout
    backgroundColor="grey"
    icon={<Info />}
    text={
      <>
        <b>Tip:</b> If you still need this item but don't want to lose track of
        this gift, increase the quantity.
      </>
    }
    variant="multi-line"
  />
)

export default QuantityCallout
